// extracted by mini-css-extract-plugin
module.exports = {"badge":"components-base-Badge-Badge__badge--bphXQ","badgeText":"components-base-Badge-Badge__badgeText--1X1yw","badgeButton":"components-base-Badge-Badge__badgeButton--332Ef"};